@if (!initializingTable) {
    <app-header/>
    <ion-content>
            <div class="errorListContainer">
                <app-log-book-error-list [errorsPagedResult]="pagedResult" [pageSizeOptions]="pageSizeOptions" [isLoading]="isLoadingErrors" [queryFilter]="logBookQueryFilter" (allErrorsSolved)="solveAllErrors()" (queryFilterChanged)="getErrorsFromLogBook($event)" />
            </div>
    </ion-content>
}
